import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({

  templateUrl: 'full-room.component.html',

  
})
export class FullRoomComponent implements OnInit, OnDestroy {
  sub
  constructor(public route: ActivatedRoute){}
 
  ngOnInit() {
    //  this.boards[0] = { wbType: "WELCOME" };
    var self = this;
    this.sub = this.route.params.subscribe(params => {
    
      let userHash = params['userHash']
      setTimeout(function(){
        window.location.href = "#/wb/" + userHash;
      },3000)
    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/full-room.compoenent.ts